export enum CustomerType {
    UNSPECIFIED = 'unspecified',
    COMPANY = 'company',
    COST_POOL = 'cost-pool',
}
